import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Styles/orderPage.css";
import Popup from "../Components/Popup";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import ReadMoreRoundedIcon from "@mui/icons-material/ReadMoreRounded";
import UpdateRounded from "@mui/icons-material/UpdateRounded";
import config from "../config";
import SearchBar from "../Components/SearchBar";
import Pagination from "../Components/Pagination";

function DrinkCategoryPage() {
  const [categoryData, setCategoryData] = useState([]);
  const [buttonNewPopup, setButtonNewPopup] = useState(false);
  const [buttonShowPopup, setButtonShowPopup] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [updatedStatus, setUpdatedStatus] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [newCategorySubmitted, setNewCategorySubmitted] = useState(false);
  const [categoryDetails, setCategoryDetails] = useState({
    name: "",
    description: "",
    isActive: true,
  });

  const [filterActive, setFilterActive] = useState(1);
  const [filterCategories, setFilterCategories] = useState("");

  const handleSearchChange = (newFilteredData) => {
    console.log('newFilteredData', newFilteredData);
    setFilteredData(newFilteredData);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  const totalCategories = filteredData.length;
  const computedCategories = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    (currentPage - 1) * itemsPerPage + itemsPerPage
  );

  const addNewCategory = () => {
    const token = localStorage.getItem('token');
    console.log('categoryDetails', categoryDetails);
    axios
      .post(
        `${config.apiEndpoint}/DrinkCategory`,
        {
          name: categoryDetails.name,
          description: categoryDetails.description,
          isActive: categoryDetails.isActive,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 201) {
          setCategoryDetails({
            name: "",
            description: "",
            isActive: true,
          });
          console.log("New drink category added successfully");
          setButtonNewPopup(false);
          setNewCategorySubmitted(!newCategorySubmitted);
        }
      })
      .catch((err) => {
        console.error("Error adding new drink category:", err);
      });
  };

  const updateCategory = () => {
    const token = localStorage.getItem('token');
    const category = categoryData[selectedCategory];
    axios
      .put(
        `${config.apiEndpoint}/DrinkCategory/${category.id}`,
        {
          id: category.id,
          name: categoryDetails.name,
          description: categoryDetails.description,
          isActive: updatedStatus,
        },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      )
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          console.log("Drink category updated successfully");
          setButtonShowPopup(false);
          setCategoryDetails({
            name: "",
            description: "",
            isActive: true,
          });
          setNewCategorySubmitted(!newCategorySubmitted);
        }
      })
      .catch((err) => {
        console.error("Error updating drink category:", err);
      });
  };

  const deleteCategory = (categoryId) => {
    const token = localStorage.getItem('token');
    axios
      .delete(`${config.apiEndpoint}/DrinkCategory/${categoryId}`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      })
      .then((res) => {
        if (res.status === 204 || res.status === 200) {
          setNewCategorySubmitted(!newCategorySubmitted);
          console.log("Drink category removed successfully");
        }
      })
      .catch((err) => {
        console.error("Error removing drink category:", err);
      });
  };



  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${config.apiEndpoint}/DrinkCategory`, { 
      headers: { Authorization: `Bearer ${token}` }, 
      withCredentials: true 
    })
      .then(res => {
        console.log('categoryData', res.data);
        setCategoryData(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Error fetching drink categories:", err);
      });
  }, [newCategorySubmitted]);

  // Auto filter when filterActive or categoryData changes
  useEffect(() => {
    if (filterActive === 1) {
      setFilteredData(categoryData);
    } else if (filterActive === 2) {
      setFilteredData(categoryData.filter(cat => cat.isActive));
    } else if (filterActive === 3) {
      setFilteredData(categoryData.filter(cat => !cat.isActive));
    }
  }, [categoryData, filterActive]);

  return (
    <div className="bodyWrap">
      <div className="contentOrderWrap">
        <div className="leftSide">
          <h1>Drink Categories</h1>
          <Pagination
            total={totalCategories}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
          <div className="orderNavWrap">
            <div className="orderNav">
              <ul>
                <li
                  className={`${filterActive === 1 ? "active" : ""}`}
                  onClick={() => {
                    setFilterCategories("");
                    setFilterActive(1);
                  }}
                >
                  All categories
                </li>
                <li
                  className={`${filterActive === 2 ? "active" : ""}`}
                  onClick={() => {
                    setFilterCategories("active");
                    setFilterActive(2);
                  }}
                >
                  Active
                </li>
                <li
                  className={`${filterActive === 3 ? "active" : ""}`}
                  onClick={() => {
                    setFilterCategories("inactive");
                    setFilterActive(3);
                  }}
                >
                  Inactive
                </li>
              </ul>
            </div>
            <div className="addOrderWrap">
              <SearchBar
                data={categoryData}
                handleSearchChange={handleSearchChange}
                dataType="drinkCategory"
                status={filterCategories}
              />
              <button
                className="addOrder"
                onClick={() => {
                  setButtonNewPopup(true);
                }}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
          <div className="orderWrap">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th>Drink Count</th>
                  <th>Created At</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {computedCategories.map((category) => {
                  return (
                    <tr key={category.id}>
                      <td>
                        <font className="maincolor">#</font>
                        {category.id}
                      </td>
                      <td>{category.name}</td>
                      <td>{category.description}</td>
                      <td>
                        <span className={`status ${category.isActive ? 'active' : 'inactive'}`}>
                          {category.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>{category.drinkCount}</td>
                      <td>{new Date(category.createdAt).toLocaleDateString()}</td>
                      <td className="maincolor">
                        <button
                          className=""
                          style={{ marginRight: "20px" }}
                          onClick={() => deleteCategory(category.id)}
                        >
                          <RemoveRoundedIcon />
                        </button>
                        <button
                          className=""
                          onClick={() => {
                            setButtonShowPopup(true);
                            setSelectedCategory(categoryData.indexOf(category));
                            setUpdatedStatus(category.isActive);
                            setCategoryDetails({
                              name: category.name,
                              description: category.description,
                              isActive: category.isActive,
                            });
                          }}
                        >
                          <ReadMoreRoundedIcon />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add New Category Popup */}
      <Popup trigger={buttonNewPopup} setTrigger={setButtonNewPopup}>
        <div className="popupWrap" style={{ height: "500px" }}>
          <div className="productSummary">
            <h3 className="productSummaryLeft">Add new drink category</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Category name"
                    className="orderDetailsInput"
                    value={categoryDetails.name}
                    onChange={(e) =>
                      setCategoryDetails({
                        ...categoryDetails,
                        name: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <textarea
                    placeholder="Description"
                    className="orderDetailsInput"
                    value={categoryDetails.description}
                    onChange={(e) =>
                      setCategoryDetails({
                        ...categoryDetails,
                        description: e.target.value,
                      })
                    }
                    rows="5"
                    style={{ minHeight: "120px", resize: "vertical" }}
                  />
                </div>
              </div>
              <div
                className="productSummaryRight newUserSwitch"
                style={{ width: "100%" }}
              >
                <h3>Is Active </h3>
                <input
                  type="radio"
                  name="addRdo"
                  id="addYes"
                  checked={categoryDetails.isActive}
                  onChange={() => setCategoryDetails({ ...categoryDetails, isActive: true })}
                />
                <input
                  type="radio"
                  name="addRdo"
                  id="addNo"
                  checked={!categoryDetails.isActive}
                  onChange={() => setCategoryDetails({ ...categoryDetails, isActive: false })}
                />
                <div className="switch">
                  <label className="switchLabel" htmlFor="addYes">
                    Yes
                  </label>
                  <label className="switchLabel" htmlFor="addNo">
                    No
                  </label>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => addNewCategory()}
              >
                <AddCircleOutlineRoundedIcon />
                <span className="addOrderText">Add</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>

      {/* Edit Category Popup */}
      <Popup trigger={buttonShowPopup} setTrigger={setButtonShowPopup}>
        <div className="popupWrap" style={{ height: "500px" }}>
          <div className="productSummary">
            <h3 className="productSummaryLeft">Edit drink category</h3>
          </div>
          <div className="addNewOrderWrap">
            <div className="addNewOrderForm">
              <div className="orderDetails">
                <div className="input-group">
                  <input
                    type="text"
                    placeholder="Category name"
                    className="orderDetailsInput"
                    value={categoryDetails.name}
                    onChange={(e) =>
                      setCategoryDetails({
                        ...categoryDetails,
                        name: e.target.value,
                      })
                    }
                    required="required"
                  />
                </div>
                <div className="input-group">
                  <textarea
                    placeholder="Description"
                    className="orderDetailsInput"
                    value={categoryDetails.description}
                    onChange={(e) =>
                      setCategoryDetails({
                        ...categoryDetails,
                        description: e.target.value,
                      })
                    }
                    rows="5"
                    style={{ minHeight: "120px", resize: "vertical" }}
                  />
                </div>
              </div>
              <div
                className="productSummaryRight newUserSwitch"
                style={{ width: "100%" }}
              >
                <h3>Is Active </h3>
                <input
                  type="radio"
                  name="editRdo"
                  id="editYes"
                  checked={updatedStatus}
                  onChange={() => setUpdatedStatus(true)}
                />
                <input
                  type="radio"
                  name="editRdo"
                  id="editNo"
                  checked={!updatedStatus}
                  onChange={() => setUpdatedStatus(false)}
                />
                <div className="switch">
                  <label className="switchLabel" htmlFor="editYes">
                    Yes
                  </label>
                  <label className="switchLabel" htmlFor="editNo">
                    No
                  </label>
                  <span></span>
                </div>
              </div>
            </div>
          </div>

          <div className="submitWrap">
            <div className="submitNewOrder">
              <button
                className="submitNewOrderBtn"
                onClick={() => updateCategory()}
              >
                <UpdateRounded />
                <span className="addOrderText">Update</span>
              </button>
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default DrinkCategoryPage;